document.addEventListener('DOMContentLoaded', async function () {

  /*
   * ============================================================
   * 1. FIND CONFIGURATOR
   * ============================================================
   */

  const configurator =
    document.getElementById('trainer-configurator');

  if (!configurator) {
    return;
  }

  const brandSelect =
    document.getElementById('trainer-brand');

  const modelSelect =
    document.getElementById('trainer-model');

  const message =
    document.getElementById('trainer-message');

  if (!brandSelect || !modelSelect || !message) {
    return;
  }


  /*
   * ============================================================
   * 2. LOAD CONFIGURATION
   * ============================================================
   */

  const configUrl =
    configurator.dataset.configUrl;

  const productType =
    configurator.dataset.productType;

  let trainers = {};
  let variantIds = {};

  try {

    const response =
      await fetch(configUrl);

    if (!response.ok) {
      throw new Error(
        `Unable to load trainer configuration: ${response.status}`
      );
    }

    const data =
      await response.json();


    /*
     * Trainer compatibility list
     */

    trainers =
      data.trainers;


    /*
     * Product-specific Shopify variants
     */

    if (
      !data.products ||
      !data.products[productType] ||
      !data.products[productType].variants
    ) {

      throw new Error(
        `No variant configuration found for product type: ${productType}`
      );

    }

    variantIds =
      data.products[productType].variants;

  } catch (error) {

    console.error(
      'Trainer configurator data failed to load:',
      error
    );

    return;
  }


  /*
   * ============================================================
   * 3. POPULATE BRAND DROPDOWN
   * ============================================================
   */

  Object.keys(trainers).forEach(function (brand) {

    const option =
      document.createElement('option');

    option.value = brand;
    option.textContent = brand;

    brandSelect.appendChild(option);

  });


  /*
   * Add Other last
   */

  const otherBrandOption =
    document.createElement('option');

  otherBrandOption.value = 'Other';
  otherBrandOption.textContent = 'Other';

  brandSelect.appendChild(
    otherBrandOption
  );


  /*
   * ============================================================
   * 4. BRAND CHANGED
   * ============================================================
   */

  brandSelect.addEventListener(
    'change',
    function () {

      populateModels(
        brandSelect.value
      );

      message.innerHTML = '';

      setAddToCartEnabled(false);

      updateUrl();

    }
  );


  /*
   * ============================================================
   * 5. MODEL CHANGED
   * ============================================================
   */

  modelSelect.addEventListener(
    'change',
    function () {

      message.innerHTML = '';

      const brand =
        brandSelect.value;

      const model =
        modelSelect.value;


      /*
       * Incomplete selection
       */

      if (!brand || !model) {

        setAddToCartEnabled(false);

        updateUrl();

        return;
      }


      /*
       * Other / unsupported trainer
       */

      if (
        brand === 'Other' ||
        model === 'Other'
      ) {

        setAddToCartEnabled(false);

        showIncompatible();

        updateUrl();

        return;
      }


      /*
       * Get trainer configuration
       */

      const trainer =
        trainers[brand]?.[model];

      if (!trainer) {

        setAddToCartEnabled(false);

        showIncompatible();

        updateUrl();

        return;
      }


      /*
       * Product-specific compatibility
       */

      if (
        trainer.compatibility?.[productType] === false
      ) {

        setAddToCartEnabled(false);

        showIncompatible(
          trainer.incompatibleWarnings?.[productType]
        );

        updateUrl();

        return;
      }


      /*
       * Resolve physical Shopify variant
       */

      const variantId =
        variantIds[trainer.variant];

      if (!variantId) {

        console.error(
          'No Shopify variant configured for:',
          trainer.variant
        );

        setAddToCartEnabled(false);

        return;
      }


      /*
       * Select real Shopify variant
       * and write line-item properties
       */

      setShopifyVariant(
        variantId
      );


      /*
       * Enable Add to Cart
       */

      setAddToCartEnabled(true);


      /*
       * Show any warnings
       */

      showCompatibility(
        trainer
      );


      /*
       * Update browser URL
       */

      updateUrl(
        variantId
      );

    }
  );


  /*
   * ============================================================
   * 6. POPULATE MODEL DROPDOWN
   * ============================================================
   */

  function populateModels(
    brand,
    selectedModel = ''
  ) {

    modelSelect.innerHTML =
      '<option value="">Trainer Model</option>';


    /*
     * No brand
     */

    if (!brand) {

      modelSelect.disabled = true;

      return;
    }


    /*
     * Other brand
     */

    if (brand === 'Other') {

      const option =
        document.createElement('option');

      option.value = 'Other';
      option.textContent = 'Other';

      modelSelect.appendChild(
        option
      );

      modelSelect.disabled = false;

      if (selectedModel === 'Other') {
        modelSelect.value = 'Other';
      }

      return;
    }


    /*
     * Unknown brand
     */

    if (!trainers[brand]) {

      modelSelect.disabled = true;

      return;
    }


    /*
     * Known models
     */

    Object.keys(
      trainers[brand]
    ).forEach(function (model) {

      const trainer =
        trainers[brand][model];


      /*
       * Hide trainers that are incompatible
       * with the current product.
       */

      if (
        trainer.compatibility?.[productType] === false
      ) {
        return;
      }


      const option =
        document.createElement('option');

      option.value = model;
      option.textContent = model;

      if (
        model === selectedModel
      ) {
        option.selected = true;
      }

      modelSelect.appendChild(
        option
      );

    });


    /*
     * Add Other last
     */

    const otherOption =
      document.createElement('option');

    otherOption.value = 'Other';
    otherOption.textContent = 'Other';

    if (
      selectedModel === 'Other'
    ) {
      otherOption.selected = true;
    }

    modelSelect.appendChild(
      otherOption
    );

    modelSelect.disabled = false;

  }


  /*
   * ============================================================
   * 7. SHOW WARNINGS
   * ============================================================
   */

  function showCompatibility(
    trainer
  ) {

    let html = '';

    if (
      trainer.warnings &&
      Array.isArray(
        trainer.warnings
      )
    ) {

      trainer.warnings.forEach(
        function (warning) {

          html += `
            <div class="trainer-warning">
              ⚠️ ${warning}
            </div>
          `;

        }
      );

    }

    message.innerHTML = html;

  }


  /*
   * ============================================================
   * 8. INCOMPATIBLE MESSAGE
   * ============================================================
   */

  function showIncompatible(
    customMessage = ''
  ) {

    const incompatibleMessage =
      customMessage ||
      `It looks like your model is not compatible.
       Please contact us if you have any questions.`;

    message.innerHTML = `
      <div class="trainer-incompatible">
        ${incompatibleMessage}
      </div>
    `;

  }


  /*
   * ============================================================
   * 8A. REQUIRED SELECTION MESSAGE
   * ============================================================
   */

  function showSelectionRequired() {

    message.innerHTML = `
      <div class="trainer-incompatible">
        Please select your trainer brand and model before adding the Zwift Ride to your cart.
      </div>
    `;

  }


  /*
   * ============================================================
   * 9. ENABLE / DISABLE ADD TO CART
   * ============================================================
   */

  function setAddToCartEnabled(enabled) {

    const buttons =
      document.querySelectorAll(
        'form[action*="/cart/add"] button[type="submit"]'
      );

    buttons.forEach(function (button) {

      /*
       * Remember Shopify's original state before
       * the configurator starts controlling it.
       */

      if (
        !button.hasAttribute(
          'data-shopify-original-disabled'
        )
      ) {

        button.setAttribute(
          'data-shopify-original-disabled',
          button.disabled ? 'true' : 'false'
        );

      }

      const shopifyDisabled =
        button.getAttribute(
          'data-shopify-original-disabled'
        ) === 'true';


      /*
       * The configurator may disable a button,
       * but must never enable something Shopify
       * originally marked unavailable.
       */

      const shouldDisable =
        !enabled || shopifyDisabled;

      button.disabled =
        shouldDisable;

      if (shouldDisable) {

        button.setAttribute(
          'aria-disabled',
          'true'
        );

      } else {

        button.removeAttribute(
          'aria-disabled'
        );

      }

    });

  }


  /*
   * ============================================================
   * 10. WRITE VARIANT + TRAINER PROPERTIES TO A FORM
   * ============================================================
   */

  function configureProductForm(
    form,
    variantId,
    brand,
    model
  ) {

    if (!form) {
      return false;
    }


    /*
     * Shopify variant
     */

    const variantInput =
      form.querySelector(
        '[name="id"]'
      );

    if (!variantInput) {

      console.error(
        'Trainer configurator could not find variant input in product form.'
      );

      return false;
    }

    variantInput.value =
      variantId;

    variantInput.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );


    /*
     * Trainer Brand line-item property
     */

    let brandProperty =
      form.querySelector(
        '[name="properties[Trainer Brand]"]'
      );

    if (!brandProperty) {

      brandProperty =
        document.createElement(
          'input'
        );

      brandProperty.type =
        'hidden';

      brandProperty.name =
        'properties[Trainer Brand]';

      form.appendChild(
        brandProperty
      );

    }


    /*
     * Trainer Model line-item property
     */

    let modelProperty =
      form.querySelector(
        '[name="properties[Trainer Model]"]'
      );

    if (!modelProperty) {

      modelProperty =
        document.createElement(
          'input'
        );

      modelProperty.type =
        'hidden';

      modelProperty.name =
        'properties[Trainer Model]';

      form.appendChild(
        modelProperty
      );

    }


    /*
     * Write current trainer selection
     */

    brandProperty.value =
      brand;

    modelProperty.value =
      model;

    return true;

  }


  /*
   * ============================================================
   * 11. SELECT SHOPIFY VARIANT
   * ============================================================
   */

  function setShopifyVariant(
    variantId
  ) {

    console.log(
      'Trainer configurator selecting variant:',
      variantId
    );

    const productForms =
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      );

    productForms.forEach(
      function (form) {

        configureProductForm(
          form,
          variantId,
          brandSelect.value,
          modelSelect.value
        );

      }
    );

  }


  /*
   * ============================================================
   * 12. UPDATE URL
   * ============================================================
   */

  function updateUrl(
    variantId = null
  ) {

    const url =
      new URL(
        window.location.href
      );


    /*
     * Brand
     */

    if (brandSelect.value) {

      url.searchParams.set(
        'brand',
        brandSelect.value
      );

    } else {

      url.searchParams.delete(
        'brand'
      );

    }


    /*
     * Model
     */

    if (modelSelect.value) {

      url.searchParams.set(
        'model',
        modelSelect.value
      );

    } else {

      url.searchParams.delete(
        'model'
      );

    }


    /*
     * Variant
     */

    if (variantId) {

      url.searchParams.set(
        'variant',
        variantId
      );

    } else {

      /*
       * Prevent stale variant IDs when the
       * customer changes/incompletes selection
       */

      url.searchParams.delete(
        'variant'
      );

    }


    window.history.replaceState(
      {},
      '',
      url
    );

  }


  /*
   * ============================================================
   * 13. RESTORE SELECTION FROM URL
   * ============================================================
   */

  function restoreFromUrl() {

    const params =
      new URLSearchParams(
        window.location.search
      );

    const brand =
      params.get('brand');

    const model =
      params.get('model');


    /*
     * Other
     */

    if (brand === 'Other') {

      brandSelect.value =
        'Other';

      populateModels(
        'Other',
        model
      );

      if (model === 'Other') {

        modelSelect.value =
          'Other';

        showIncompatible();

      }

      return;
    }


    /*
     * Invalid / missing brand
     */

    if (
      !brand ||
      !trainers[brand]
    ) {
      return;
    }


    /*
     * Restore brand
     */

    brandSelect.value =
      brand;


    /*
     * Populate models
     */

    populateModels(
      brand,
      model
    );


    /*
     * Restore valid model
     */

    if (
      model &&
      trainers[brand][model] &&
      trainers[brand][model].compatibility?.[productType] !== false
    ) {

      modelSelect.value =
        model;

      const trainer =
        trainers[brand][model];


      /*
       * Check product-specific compatibility
       */

      if (
        trainer.compatibility?.[productType] === false
      ) {

        setAddToCartEnabled(false);

        showIncompatible(
          trainer.incompatibleWarnings?.[productType]
        );

        updateUrl();

        return;
      }


      /*
       * Resolve physical Shopify variant
       */

      const variantId =
        variantIds[
          trainer.variant
        ];

      if (variantId) {

        setShopifyVariant(
          variantId
        );

        setAddToCartEnabled(
          true
        );

        showCompatibility(
          trainer
        );

      }

    } else if (
      model === 'Other'
    ) {

      modelSelect.value =
        'Other';

      showIncompatible();

    }

  }


  /*
   * ============================================================
   * 14. HARD SUBMIT VALIDATION
   * ============================================================
   *
   * This is deliberately attached to document in capture mode.
   *
   * Even if Shopify, Dawn or an app replaces/re-enables the
   * Add to Cart button after this configurator initialized,
   * a Ride cannot be submitted without a valid trainer.
   *
   * It also rewrites the expected Shopify variant and trainer
   * line-item properties immediately before submission.
   * ============================================================
   */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target;

      if (
        !form ||
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }


      const brand =
        brandSelect.value;

      const model =
        modelSelect.value;


      /*
       * No trainer selected
       */

      if (
        !brand ||
        !model
      ) {

        event.preventDefault();
        event.stopImmediatePropagation();

        showSelectionRequired();

        setAddToCartEnabled(false);

        configurator.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }


      /*
       * Explicit Other selection
       */

      if (
        brand === 'Other' ||
        model === 'Other'
      ) {

        event.preventDefault();
        event.stopImmediatePropagation();

        showIncompatible();

        setAddToCartEnabled(false);

        configurator.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }


      /*
       * Trainer must exist in configuration
       */

      const trainer =
        trainers[brand]?.[model];

      if (!trainer) {

        event.preventDefault();
        event.stopImmediatePropagation();

        showIncompatible();

        setAddToCartEnabled(false);

        configurator.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }


      /*
       * Trainer must be compatible with
       * this specific product.
       */

      if (
        trainer.compatibility?.[productType] === false
      ) {

        event.preventDefault();
        event.stopImmediatePropagation();

        showIncompatible(
          trainer.incompatibleWarnings?.[productType]
        );

        setAddToCartEnabled(false);

        configurator.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }


      /*
       * Resolve the expected Shopify variant
       */

      const variantId =
        variantIds[
          trainer.variant
        ];

      if (!variantId) {

        event.preventDefault();
        event.stopImmediatePropagation();

        console.error(
          'No Shopify variant configured for:',
          trainer.variant
        );

        message.innerHTML = `
          <div class="trainer-incompatible">
            We could not configure this trainer selection. Please contact us for assistance.
          </div>
        `;

        setAddToCartEnabled(false);

        configurator.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }


      /*
       * FINAL FAIL-SAFE
       *
       * Immediately before Shopify / Dawn / Downpay sees
       * the submission, make sure the submitted form contains:
       *
       * - correct Shopify variant
       * - Trainer Brand
       * - Trainer Model
       */

      const configured =
        configureProductForm(
          form,
          variantId,
          brand,
          model
        );

      if (!configured) {

        event.preventDefault();
        event.stopImmediatePropagation();

        message.innerHTML = `
          <div class="trainer-incompatible">
            We could not configure this order correctly. Please refresh the page and try again.
          </div>
        `;

        return;
      }

    },

    /*
     * Capture phase.
     *
     * This causes our validation to run before most
     * Shopify / theme / app submit handlers.
     */
    true
  );


  /*
   * ============================================================
   * 15. INITIALISE
   * ============================================================
   */

  setAddToCartEnabled(false);

  restoreFromUrl();

});